



























import VueOptions from '@utils/VueOptions'

settings =
  name: 'EventBrandOfferSection'
  vue:
    props: ['event', 'canEdit']
    methods:
      brandImageForOffer: (offer) -> false
export default VueOptions.vue settings
